/**
 * Calculate expiring and expired dates from specified periods and current date
 */
export function getExpiringAndExpiredDates(periods) {
    if (!periods.expiredPeriodDays || periods.expiredPeriodDays <= 0 || periods.expiringPeriodDays > periods.expiredPeriodDays) {
        return { dateWhenExpiring: undefined, dateWhenExpired: undefined };
    }
    const dateWhenExpired = new Date();
    dateWhenExpired.setDate(dateWhenExpired.getDate() - periods.expiredPeriodDays);
    let dateWhenExpiring = undefined;
    if (periods.expiringPeriodDays && periods.expiringPeriodDays >= 0) {
        dateWhenExpiring = new Date(dateWhenExpired);
        dateWhenExpiring.setDate(dateWhenExpiring.getDate() + periods.expiringPeriodDays);
    }
    return { dateWhenExpired: dateWhenExpired, dateWhenExpiring: dateWhenExpiring };
}
